import React from "react";
import classNames from "classnames";
import "./index.scss";

import RoleManager from "../../../services/roleManage";

import SectionItemSwitch from "../SectionItemSwitch";
import ColumnTitleWithIcon from "../ColumnTitleWithIcon/index.js";

const SectionItemSwitchGroups = ({ item, column, model, onPropChange }) => {
    return (
        <div className={classNames("sectionItemSwitchGroups", { isInline: column.isInline })}>
            <ColumnTitleWithIcon item={item} column={column} onPropChange={onPropChange}/>
            {column.items.map((group, groupIndex)=> (
                <div key={`sectionItemSwitchGroup-${groupIndex}`} className={classNames("sectionItemSwitchGroup")}>
                    {group.filter(col => col.isShow ? col.isShow() : true).map(col=> (
                        <SectionItemSwitch key={`switchGroupItem-${col.accessor}`}
                            value={item[col.accessor]} 
                            column={{...col, isReadonly:
                                    RoleManager.instance.isReadonlyPage(model.typeModel) ||
                                    !RoleManager.instance.isAccessorAuthorized(model.typeModel, col.accessor)
                                    || !col.isEditable}
                        }
                            onPropChange={onPropChange} 
                        />
                    ))}
                </div>
            ))}
        </div>
    );
}

export default SectionItemSwitchGroups;